import isRelativeUrl from 'is-relative-url';
import normalizeUrl from 'normalize-url';

export function isUrl(str: string): boolean {
  try {
    const url = new URL(str);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch (_error) {
    return false;
  }
}

const deleteQueryParams = (url: string, queryParams: string[]) => {
  try {
    const urlObj = new URL(url);
    queryParams.forEach((queryParam) => urlObj.searchParams.delete(queryParam));
    return urlObj.toString();
  } catch {
    console.error('Failed to remove query params');
    return url;
  }
};

// Urls will be consider equal if their normalized relative path + search params are equal
export const compareUrls = (
  url1: string,
  url2: string,
  options: { ignoredQueryParams?: string[] } = {}
) => {
  const getAbsoluteUrl = (url: string) =>
    isRelativeUrl(url) ? window.origin + url : url;

  const getRelativeUrl = (url: string) => {
    const { pathname, search } = new URL(url);
    return pathname + search;
  };

  const transformUrl = (url: string) =>
    getRelativeUrl(
      deleteQueryParams(
        normalizeUrl(getAbsoluteUrl(url)),
        options.ignoredQueryParams ?? []
      )
    );

  return transformUrl(url1) === transformUrl(url2);
};

export function getUrlObject(url: string) {
  try {
    return new URL(url);
  } catch (error) {
    console.error(`${error} ${url}`);
    return;
  }
}

export function getDecodedUrlToDisplay(decodedUrl: string): string {
  return !decodedUrl?.startsWith('https://')
    ? `https://${decodedUrl}`
    : decodedUrl;
}
